import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {noPropagate} from '@containers/hooks'
import {useCalendarStore} from '../../calendar-store'
import {useDraggableStore} from '../draggable/draggable-store'
import {AddTask} from './add-task'
import IconAddTask from './icon-add-task.svg'

const TaskContentTw = tw.div`
  h-60
  z-20
`

interface Props {
  start: Date
  end: Date
}

export const AddTaskPopup = observer(({start, end}: Props) => {
  const iconRef = useRef<HTMLDivElement>(null)
  const [state] = useCalendarStore()
  const [draggableState] = useDraggableStore()

  if (
    start !== state.showPopupButton.hour ||
    !state.showPopupButton.value ||
    draggableState.enabled ||
    draggableState.draggedItem.id
  ) {
    return null
  }

  return (
    <div
      onMouseMove={noPropagate}
      onMouseLeave={noPropagate}
      onMouseEnter={noPropagate}
    >
      <Dropdown
        animation={false}
        duration={0}
        visible={state.openedPopup}
        content={<AddTask start={start} end={end} />}
        reference={iconRef}
      >
        {state.openedPopup ? (
          <div ref={iconRef}>
            <TaskContentTw />
          </div>
        ) : (
          <div ref={iconRef}>
            {state.checkAddTask && (
              <div className="absolute pointer-events-none top-18 text-action-default">
                <IconAddTask />
              </div>
            )}
          </div>
        )}
      </Dropdown>
    </div>
  )
})
